




















































































































import { FormModal, Toggle } from '@/app/components';
import { defineComponent, ref, watch } from '@vue/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_} is required',
});

extend('numeric', {
    ...numeric,
    message: '{_field_} must be a number',
});

export default defineComponent({
    name: 'RunnerConfigureModal',
    components: { FormModal, ValidationProvider, ValidationObserver, Toggle },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
        runner: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const observer = ref<any>(null);
        const config = ref({
            endpoint: '',
            port: 9000,
            useSSL: false,
            accessKey: '',
            secretKey: '',
            serverPort: 6000,
        });

        const handleSubmit = async () => {
            const isValid = await observer.value.validate();
            if (isValid) {
                emit('submit', config.value);
            }
        };

        // Reset form when modal is closed
        watch(
            () => props.show,
            (newValue) => {
                if (!newValue) {
                    config.value = {
                        endpoint: '',
                        port: 9000,
                        useSSL: false,
                        accessKey: '',
                        secretKey: '',
                        serverPort: 6000,
                    };
                    observer.value?.reset();
                }
            },
        );

        return {
            observer,
            config,
            handleSubmit,
        };
    },
});
